import { call, takeLatest, put } from 'redux-saga/effects';
import { post, get } from '../../helpers/server';

function* actionGetPortfolioInfo(action) {
    try {
        const resp = yield call(get, "/portfolio/info?u=" + action.payload.UserId);
        if (resp.status === 1) {
            yield put({ type: "info_success", permission: resp.p });
        } else {
            if (resp.status === 2) {
                yield put({ type: "non_user" });
            }
            yield put({ type: "info_fail", status: resp.status });
        }
    } catch (e) {
        yield put({ type: "info_fail", status: 0 });
    }
}

function* actionStartPortfolio(action) {
    try {
        const resp = yield call(post, "/portfolio/startPortfolio", action.payload);
        if (resp.status === 1) {
            yield put({ type: "start_portfolio_success", portfolioId: resp.portfolioId });
        } else {
            if (resp.status === 2) {
                yield put({ type: "non_user" });
            }
            yield put({ type: "start_portfolio_fail", status: resp.status });
        }
    } catch (e) {
        yield put({ type: "start_portfolio_fail", status: 0 });
    }
}

function* actionGetPortfolioItems(action) {
    try {
        const resp = yield call(get, "/portfolio/items?u=" + action.payload.u);
        if (resp.status === 1) {
            yield put({ type: "get_portfolio_items_success", portfolioItems: resp.items });
        } else {
            if (resp.status === 2) {
                yield put({ type: "non_user" });
            }
            yield put({ type: "get_portfolio_items_fail", status: resp.status });
        }
    } catch (e) {
        yield put({ type: "get_portfolio_items_fail", status: 0 });
    }
}

function* actionPortfolioOptItems(action) {
    try {
        const resp = yield call(get, "/portfolio/portfolitOptitems?u=" + action.payload.u);
        if (resp.status === 1) {
            yield put({ type: "portfolio_opt_items_success", portfolioItems: resp.items });
        } else {
            if (resp.status === 2) {
                yield put({ type: "non_user" });
            }
            yield put({ type: "portfolio_opt_items_fail", status: resp.status });
        }
    } catch (e) {
        yield put({ type: "portfolio_opt_items_fail", status: 0 });
    }
}

function* actionGetPortfolioOptItems(action) {
    try {
        const resp = yield call(get, "/portfolio/getPortfolitOptitems?u=" + action.payload.u + "&pId=" + action.payload.pId);
        if (resp.status === 1) {
            yield put({ type: "get_portfolio_opt_items_success", portfolioItems: resp.items });
        } else {
            if (resp.status === 2) {
                yield put({ type: "non_user" });
            }
            yield put({ type: "get_portfolio_opt_items_fail", status: resp.status });
        }
    } catch (e) {
        yield put({ type: "get_portfolio_opt_items_fail", status: 0 });
    }
}

function* actionRemovePortfolio(action) {
    try {
        const resp = yield call(post, "/portfolio/remove", action.payload);
        if (resp.status === 1) {
            yield put({ type: "remove_portfolio_success" });
        } else {
            if (resp.status === 2) {
                yield put({ type: "non_user" });
            }
            yield put({ type: "remove_portfolio_fail", status: resp.status });
        }
    } catch (e) {
        yield put({ type: "remove_portfolio_fail", status: 0 });
    }
}

function* Effect() {
    yield takeLatest('action_get_portfolio_info', actionGetPortfolioInfo);

    yield takeLatest('action_start_portfolio', actionStartPortfolio);

    yield takeLatest('action_get_portfolio_items', actionGetPortfolioItems);

    yield takeLatest('action_remove_portfolio', actionRemovePortfolio);

    yield takeLatest('action_portfolio_opt_items', actionPortfolioOptItems);
    yield takeLatest('action_get_portfolio_opt_items', actionGetPortfolioOptItems);
    
    
}

export default Effect;